const global = (theme) => {
  const output = {
    root: {},
    '@global': {
      body: {
        extend: theme.typography.general,
        color: theme.colors[2],
        background: theme.colors[3],
        overflowY: theme.detect.isNativeScroll || window.innerWidth <= 1280 || theme.detect.isIE11 ? 'visible' : 'hidden',
        overflowX: 'hidden',
        '& a': {
          textDecoration: 'none',
          transition: 'color .3s ease-in-out',
        },
        '& button': {
          fontSize: 16,
          fontFamily: theme.fonts[0],
          padding: 0,
        },
        '& input': {
          fontSize: 16,
          fontFamily: theme.fonts[0],
          padding: 0,
        },
        '& h1, & h2, & h3, & h4': {
          fontWeight: 'normal',
          margin: 0,
          padding: 0,
        },
        '& .ecwid-popup': {
          top: '0 !important',
          position: 'fixed !important',
          height: '100vh',
          overflowY: 'scroll !important',
        },
        '& .popupContent': {
          marginTop: '30px!important',
          minHeight: 'calc(100vh - 60px)',
        },
      },
      '::selection': {
        background: theme.colors[10],
        color: theme.colors[0],
      },
      '::-moz-selection': {
        background: theme.colors[10],
        color: theme.colors[0],
      },
    },
  }

  output[theme.mediaInverse.lg] = {}

  output[theme.mediaInverse.sm] = {
    '@global': {
      body: {
        '& .popupContent': {
          borderRadius: '0 !important',
        },
      },
    },
  }

  return output
}

export default global
